import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';

import Layout from '../components/layout';

const getImages = () => {
  const { allFile } = useStaticQuery(
    graphql`
      query {
        allFile(filter: { sourceInstanceName: { eq: "paintings" } }) {
          edges {
            node {
              childImageSharp {
                fluid(maxWidth: 3840, quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
              name
            }
          }
        }
      }
    `,
  );
  return allFile.edges;
};

const Paintings = () => {
  const images = getImages();
  return (
    <Layout>
      <h2>🎨 Paintings 🎨</h2>
      <center>A collection of paintings and artworks</center>
      {images.map((img: any) => {
        return (
          <Img
            fluid={img.node.childImageSharp.fluid}
            alt={img.node.name}
            key={img.node.name}
          />
        );
      })}
    </Layout>
  );
};

export default Paintings;
